import { lock } from "@/util/lock";

const lockDirective = {
  mounted(el, binding) {
    if (binding.value instanceof Function) {
      el.__lockHandler__ = lock(binding.value);
      el.addEventListener("click", el.__lockHandler__);
    }
  },
  updated(el, binding) {
    if (el.__lockHandler__) {
      el.removeEventListener("click", el.__lockHandler__);
      delete el.__lockHandler__;
    }
    if (binding.value instanceof Function) {
      el.__lockHandler__ = lock(binding.value);
      el.addEventListener("click", el.__lockHandler__);
    }
  },
  beforeUnmount(el) {
    if (el.__lockHandler__) {
      el.removeEventListener("click", el.__lockHandler__);
      delete el.__lockHandler__;
    }
  },
};

export default lockDirective;
